import { Card } from '@/components/ui/card';
import { Mail, Clock, CheckCircle, TrendingUp } from 'lucide-react';

interface MessageStatsProps {
  totalMessages: number;
  unreadCount: number;
  todayCount: number;
}

const MessageStats = ({ totalMessages, unreadCount, todayCount }: MessageStatsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      <Card className="glass p-6 border-glow">
        <div className="flex items-center gap-4">
          <div className="p-3 rounded-lg bg-gradient-cyber">
            <Mail className="w-6 h-6 text-primary-foreground" />
          </div>
          <div>
            <p className="text-2xl font-bold">{totalMessages}</p>
            <p className="text-sm text-muted-foreground">Total Messages</p>
          </div>
        </div>
      </Card>
      
      <Card className="glass p-6 border-glow">
        <div className="flex items-center gap-4">
          <div className="p-3 rounded-lg bg-gradient-web">
            <Clock className="w-6 h-6 text-primary-foreground" />
          </div>
          <div>
            <p className="text-2xl font-bold">{unreadCount}</p>
            <p className="text-sm text-muted-foreground">Unread Messages</p>
          </div>
        </div>
      </Card>
      
      <Card className="glass p-6 border-glow">
        <div className="flex items-center gap-4">
          <div className="p-3 rounded-lg bg-gradient-software">
            <CheckCircle className="w-6 h-6 text-primary-foreground" />
          </div>
          <div>
            <p className="text-2xl font-bold">{totalMessages - unreadCount}</p>
            <p className="text-sm text-muted-foreground">Read Messages</p>
          </div>
        </div>
      </Card>

      <Card className="glass p-6 border-glow">
        <div className="flex items-center gap-4">
          <div className="p-3 rounded-lg bg-gradient-keyboard">
            <TrendingUp className="w-6 h-6 text-primary-foreground" />
          </div>
          <div>
            <p className="text-2xl font-bold">{todayCount}</p>
            <p className="text-sm text-muted-foreground">Today</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default MessageStats;
